import { codeManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];
const viewAndListPermission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const codeManagementRouteMetadata: IRouteMetadataObj<
  typeof codeManagementRoutesObj
> = {
  list: {
    title: "codeManagement.index.title",
    description: "codeManagement.index.description",
    lazy: () => import("@/pages/codeManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "Coupon3Line",
    breadcrumbs: [],
    permission: viewAndListPermission,
  },
  create: {
    title: "codeManagement.create.title",
    description: "codeManagement.create.description",
    lazy: () => import("@/pages/codeManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  addMore: {
    title: "codeManagement.edit.title",
    description: "codeManagement.edit.description",
    lazy: () => import("@/pages/codeManagement/addMore/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "codeManagement.view.title",
    description: "codeManagement.view.description",
    lazy: () => import("@/pages/codeManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "codeManagement.view.title",
    description: "codeManagement.view.description",
    lazy: () => import("@/pages/codeManagement/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission: viewAndListPermission,
  },
};

export const codeManagementRoutes = createRoute<typeof codeManagementRoutesObj>(
  codeManagementRoutesObj,
  codeManagementRouteMetadata,
);
